module.exports = __webpack_public_path__ + "static/media/Sara.d7b48aa7.png";